import { Action } from "../types"
import { ToastAction } from "./actions"
import { ToastState } from "./types"

const initial_toast: ToastState = {
  toasts: []
}

const toastReducer = (state = initial_toast, action: Action) => {
  const { data, type } = action ?? {}
  switch (type) {
    case ToastAction.ADD_TOAST:
      const tempToasts = [...state.toasts]
      tempToasts.push(data)
      return {
        ...state,
        toasts: tempToasts
      }
      break

    case ToastAction.REMOVE_TOAST:
      const temp = [...state.toasts]
      temp.splice(data, 1)
      return {
        ...state,
        toasts: temp
      }
      break

    default:
      return state
  }
}

export { toastReducer, initial_toast }
